// class StoreLocator extends HTMLElement {
//   constructor() {
//     super();
//     this.item = this.querySelectorAll('.item');
//     this.map = this.querySelector('#map');

//     if (this.item) this.item.forEach(item => {item.addEventListener('click', this.onButtonClick.bind(this))});
//   }

//   onButtonClick(event) {
//     const target = event.currentTarget;
//     const map = target.dataset.map;
//     this.map.classList.add('map-loading');
//     this.querySelector('.active').classList.remove('active');
//     target.classList.add('active');
//     setTimeout(() => {this.map.innerHTML = map}, 300);
//     setTimeout(() => {this.map.classList.remove('map-loading')}, 1200);
//   }
// }
// customElements.define('store-locator', StoreLocator);

var script = document.createElement("script");
script.src =
  // "https://maps.googleapis.com/maps/api/js?key=AIzaSyAJOuMtTfHyqlYCp1dn1YSeG-8VmRgH4aE";
  // "https://maps.googleapis.com/maps/api/js?key=AIzaSyDro-Ch4MMlpFfvto_PkDQ9E0t9XWDwfnM";
  "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHHR7ftp-18Oyl9Ghfy7K9QkMPsE1p-Mw";
script.defer = true;
document.head.appendChild(script);
document.addEventListener("DOMContentLoaded", function () {
  let map,
    infoWindow,
    userLocation = null;
  let markers = [];
  let searchRadius = 100; // Bán kính tìm kiếm cố định là 100 dặm
  let currentZoomLevel = 10; // Mức zoom ban đầu
  let dealers = []; // Mảng lưu trữ dữ liệu đại lý sẽ được tải từ file JSON
  let activeInfoWindow = null;
  let activeMarker = null;
  let lastQuery = null;
  let zoomChangedListeners = []; // Lưu listener cho zoom_changed
  // Hàm để tải dữ liệu từ file JSON
  function loadDealersData() {
    const timestamp = Date.now();
    fetch(
      `https://api.copperheadag.com/api-maps/api-get-companies-sql.php?v=${timestamp}`
    ) // Đường dẫn tới API của bạn
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json(); // Chuyển đổi phản hồi thành JSON
      })
      .then((data) => {
        dealers = data; // Lưu trữ dữ liệu từ API vào biến dealers
        // console.log("data ======>",data)
        initMap(); // Khởi tạo bản đồ sau khi dữ liệu được tải xong
      })
      .catch((error) => {
        console.error("Error loading dealer data:", error);
      });
  }

  function initMap() {
    map = new google.maps.Map(document.getElementById("map"), {
      zoom: currentZoomLevel,
      center: { lat: 37.0902, lng: -95.7129 }, // Trung tâm Hoa Kỳ ban đầu
    });

    infoWindow = new google.maps.InfoWindow();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // User allowed location detection
          userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          // userLocation = {
          //     lat: 44.299782,  
          //     lng: -99.423186 
          // };
          // userLocation = {
          //     lat: 40.7128,  // Latitude của New York City
          //     lng: -74.0060  // Longitude của New York City
          // };
          map.setCenter(userLocation);
          map.setZoom(10); // Default zoom level for user's location

          // Find dealers within the radius based on user's location
          searchDealersWithinRadius(userLocation, searchRadius, 0, '');

          // Listen for map zoom changes
          const listener1 = google.maps.event.addListener(map, "zoom_changed", () => {
              const newZoom = map.getZoom();
              
              const newRadius = getRadiusFromZoom(newZoom); // Tính bán kính mới dựa trên zoom
              // console.log(newRadius, newZoom);
              searchDealersWithinRadius(userLocation, newRadius, 1, ''); // Tìm đại lý trong bán kính mới
              
          });
          zoomChangedListeners.push(listener1);
        },
        (error) => {
          // User denied location detection
          // console.error("Error in geolocation:", error.message);
          handleNoGeolocation(true); // Show US map with no pins and no list
        },
        { enableHighAccuracy: true } // Increase geolocation accuracy
      );
    } else {
      handleNoGeolocation(false); // If geolocation is not supported
    }
  }

  // Gọi hàm loadDealersData khi trang được tải
  window.onload = function () {
    loadDealersData(); // Tải dữ liệu đại lý từ file JSON
  };

  function getRadiusFromZoom(zoomLevel) {

    const baseRadius = 100;
    const zoomIncrement = 100;
    const minRadius = 100;
    const radius = baseRadius + (zoomLevel - 10) * zoomIncrement;
    if (radius >= 0) {
      return minRadius;
    }
    return Math.max(Math.abs(radius), 100);
  }

  // Tìm kiếm đại lý trong bán kính
  function searchDealersWithinRadius(center, radius, zoom_change = 0, query = '') {
    let combinedDealers = [];
    
    // const filteredDealers = dealers.filter((dealer) => {
    //   const distance = calculateDistance(center, {
    //     lat: parseFloat(dealer.lat),
    //     lng: parseFloat(dealer.long),
    //   });

    //   const stateExists = dealer.state && dealer.state.toLowerCase().includes(query);
    //   const postalCodeExists = dealer.zipcode && dealer.zipcode.includes(query);
    //   return distance <= radius && (stateExists || postalCodeExists); // Lọc các đại lý nằm trong bán kính
    // });
     const filteredDealers = dealers.filter((dealer) => {
      const distance = calculateDistance(center, {
        lat: parseFloat(dealer.lat),
        lng: parseFloat(dealer.long),
      });
      dealer.distance = distance; // Lưu khoảng cách vào từng đại lý
      return distance <= radius; // Lọc các đại lý nằm trong bán kính
    }).sort((a, b) => a.distance - b.distance);
  
    const additionalDealers = dealers.filter((dealer) => {
      const distance = calculateDistance(center, {
        lat: parseFloat(dealer.lat),
        lng: parseFloat(dealer.long),
      });
      dealer.distance = distance; // Lưu khoảng cách vào từng đại lý
      const stateExists = dealer.state && dealer.state.toLowerCase().includes(query);
      const postalCodeExists = dealer.zipcode && dealer.zipcode.includes(query);
      return distance <= radius && (stateExists || postalCodeExists); // Lọc các đại lý nằm trong bán kính
    }).sort((a, b) => a.distance - b.distance);
    

    const stockingDealers = filteredDealers.filter(dealer =>
      dealer.dealer_type.toLowerCase() === "stocking dealer"
    );
    const hasStockingDealer = filteredDealers.some(
      (dealer) => dealer.dealer_type.toLowerCase() === "stocking dealer"
    );
  
    if (hasStockingDealer) {
    // if ((stockingDealers.length > 0)) {
 
      clearMarkers(); // Xóa các marker cũ
      // combinedDealers =  [...filteredDealers, ...additionalDealers];
      combinedDealers = [...filteredDealers, ...additionalDealers].filter(
        (dealer, index, self) =>
          index === self.findIndex((d) => d.record_id === dealer.record_id)
      );
      // console.log(combinedDealers);
      updateDealerList(combinedDealers, center); // Cập nhật danh sách đại lý
      plotDealersOnMap(combinedDealers); // Hiển thị các đại lý trong bán kính trên bản đồ
      drawSearchRadiusCircle(center, radius); // Vẽ vòng tròn bán kính trên bản đồ
    } else {
      let nearestDealers = findNearestDealers(center, 3); // Tìm 1 hoặc 3 đại lý gần nhất
      
      if (nearestDealers.length > 0) {
        clearMarkers(); // Xóa các marker cũ
        clearMapAndList();
        // Kết hợp stocking dealers và các dealer trong khu vực bán kính
        if (zoom_change == 1 ){
          // combinedDealers = [...nearestDealers, ...additionalDealers,...filteredDealers];
          combinedDealers = [...filteredDealers, ...additionalDealers].filter(
            (dealer, index, self) =>
              index === self.findIndex((d) => d.record_id === dealer.record_id)
          );
        } else {
          // combinedDealers = [...nearestDealers];
          combinedDealers = [...filteredDealers, ...additionalDealers].filter(
            (dealer, index, self) =>
              index === self.findIndex((d) => d.record_id === dealer.record_id)
          );
        }
        updateDealerList(combinedDealers, center); // Cập nhật danh sách với các dealer gần nhất
        plotDealersOnMap(combinedDealers); // Hiển thị các đại lý trên bản đồ

      } else {
        clearMapAndList(); // Xóa danh sách và marker nếu không tìm được đại lý
      }

      drawSearchRadiusCircle(center, radius); // Vẽ vòng tròn bán kính giữ nguyên vị trí
    }
  }

  function findNearestDealers(center, maxResults = 3) {
    // Lọc chỉ các Stocking Dealer từ danh sách đại lý
    const stockingDealers = dealers.filter(
      (dealer) => dealer.dealer_type.toLowerCase() === "stocking dealer"
    );

    // Sắp xếp các Stocking Dealer theo khoảng cách từ vị trí tìm kiếm
    const sortedStockingDealers = stockingDealers
      .map((dealer) => {
        const distance = calculateDistance(center, {
          lat: parseFloat(dealer.lat),
          lng: parseFloat(dealer.long),
        });

        return { ...dealer, distance}; // Đính kèm khoảng cách với từng đại lý
      })
      .sort((a, b) => a.distance - b.distance); // Sắp xếp theo khoảng cách gần nhất

    // Trả về các Stocking Dealer gần nhất (tối đa maxResults)
    return sortedStockingDealers.slice(0, maxResults);
  }

  let searchCircle;

  function drawSearchRadiusCircle(center, radius) {
    // Nếu đã có một vòng tròn trước đó, xóa nó trước
    if (searchCircle) {
      searchCircle.setMap(null);
    }

    // Kiểm tra nếu center có giá trị hợp lệ
    if (center && center.lat && center.lng) {
      searchCircle = new google.maps.Circle({
        strokeColor: "#808080", // Màu gray cho viền
        strokeOpacity: 0.5, // Độ mờ của viền
        strokeWeight: 2, // Độ dày của viền
        fillColor: "#808080", // Màu gray nhạt cho phần bên trong
        fillOpacity: 0.35, // Độ mờ của phần bên trong
        map: map,
        center: center, // Vị trí trung tâm vòng tròn
        radius: radius * 1609.34, // Bán kính chuyển đổi từ dặm sang mét
      });
    }
  }
  // Hàm để tắt hoặc xóa vòng tròn
  function removeSearchRadiusCircle() {
      if (searchCircle) {
          searchCircle.setMap(null); // Xóa vòng tròn khỏi bản đồ
          searchCircle = null; // Đặt lại biến để tránh lỗi lần sau
      }
  }

  // Tính khoảng cách giữa hai điểm
  function calculateDistance(location1, location2) {
    const R = 3958.8; // Bán kính Trái đất theo dặm
    const dLat = ((parseFloat(location2.lat) - parseFloat(location1.lat)) * Math.PI) / 180;
    const dLon = ((parseFloat(location2.lng) - parseFloat(location1.lng)) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((parseFloat(location1.lat) * Math.PI) / 180) *
        Math.cos((parseFloat(location2.lat) * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Khoảng cách tính bằng dặm
    return parseFloat(distance.toFixed(5));
  }

  // Cập nhật danh sách đại lý
  function updateDealerList(dealersList, location = null) {
    const listElement = document.getElementById("dealerList");
    listElement.innerHTML = ""; // Xóa danh sách cũ
    let sortedDealers = dealersList;
    // Lọc các Stocking Dealers từ kết quả tìm kiếm
    const stockingDealersInSearch = sortedDealers.filter(
      (dealer) => dealer.dealer_type.toLowerCase() === "stocking dealer"
    );

    // Nếu không có Stocking Dealer trong kết quả tìm kiếm, thêm các Stocking Dealer gần nhất
    if (stockingDealersInSearch.length === 0 && location) {
      const nearestStockingDealers = findNearestDealers(location, 3);
      sortedDealers.push(...nearestStockingDealers); // Thêm các Stocking Dealer gần nhất vào danh sách
    }

    // Sắp xếp các đại lý: "Stocking Dealer" xuất hiện trước
    sortedDealers = dealersList.sort((a, b) => {
      if (
        a.dealer_type === "Stocking Dealer" &&
        b.dealer_type !== "Stocking Dealer"
      ) {
        return -1; // "Stocking Dealer" lên trước
      }
      if (
        a.dealer_type !== "Stocking Dealer" &&
        b.dealer_type === "Stocking Dealer"
      ) {
        return 1; // Các đại lý khác xuống dưới
      }
      return 0; // Không thay đổi vị trí nếu cả hai cùng loại
    });

    // Duyệt qua danh sách đại lý đã được sắp xếp và tạo các phần tử li
    // console.log("sortedDealers ==>",sortedDealers);
    const query_zip = document.getElementById("search-box").value.toLowerCase();
    
     const filteredDealers_zip = dealers.filter((dealer) => {
            // Chuẩn hóa query ZIP (thêm 0 nếu thiếu)
            const normalizedQuery_zip = query_zip.padStart(5, '0');
        
            // Chuẩn hóa ZIP của dealer (thêm 0 nếu thiếu)
            const dealerZip_zip = dealer.zipcode ? dealer.zipcode.padStart(5, '0') : '';
        
            const stateExists_zip =
                dealer.state && dealer.state.toLowerCase().includes(query_zip.toLowerCase());
        
            const postalCodeExists =
                dealerZip_zip.includes(normalizedQuery_zip);
        
            return stateExists_zip || postalCodeExists;
        });

    console.log("filteredDealers_zip ==>",filteredDealers_zip);

    const dealersToShow = filteredDealers_zip.length > 0 ? filteredDealers_zip : sortedDealers;

    // console.log(dealersToShow, "<<<< dealersToShow>>> ")

      // console.log("Dealers to show:", dealersToShow.map(d => d.business_name));

      const dealerList = document.getElementById("dealerList");
      dealerList.innerHTML = "";
      
      // dealersToShow.forEach(dealer => {
      //   const li = document.createElement("li");
      //   li.textContent = dealer.business_name;
      //   dealerList.appendChild(li);
      // });-

    sortedDealers.forEach((dealer) => {
    
    // dealersToShow.forEach((dealer) => {
      const li = document.createElement("li");
      li.innerHTML = `<div class="info-dealer">
                      <div class="info-dealer-inn">
                        <h3 class="title dealer-heading-first" ${
                          dealer.dealer_type === "Stocking Dealer"
                            ? `style="color: #d0a50b;"`
                            : `style="color: #00452b;"`
                        }>${
        dealer.business_name ? dealer.business_name : ""
      }</h3>
                        ${
                          dealer.dealer_type === "Stocking Dealer"
                            ? `<span class="dealer-sub">(Stocking Dealer)</span>`
                            : ""
                        }
                        ${
                          dealer.dealer_type === "Non-Stocking Dealer"
                            ? `<span class="dealer-sub non-stocking-dealer">(Non-Stocking Dealer)</span>`
                            : ""
                        }
                      </div>
                      <h3 class="title dealer-heading-second">${
                        dealer.address ? dealer.address : ""
                      }</h3>
                      <p class=" dealer-address">${dealer.city ? dealer.city : ""}, ${
        dealer.state_code ? dealer.state_code : ""
      } ${dealer.state ? dealer.state : ""}, ${
        dealer.zipcode ? dealer.zipcode : ""
      }</p>
                      <p class=" dealer-pera-phone">${dealer.phone ? dealer.phone : ""}</p>
                       <p class="purchase-parts">Purchase Parts</p>  
                  </div>`;

      // Gắn sự kiện click cho mỗi đại lý trong danh sách
      li.addEventListener("click", () => {
        // Tìm marker tương ứng với đại lý này
        const markerData = markers.find(
          (m) => m.dealer.business_name === dealer.business_name
        );
        if (markerData) {
          const marker = markerData.marker;

          // Hiển thị InfoWindow trên marker tương ứng
          infoWindow.setContent(
            `<div class="popup-info-marker">
                      ${
                        dealer.dealer_type === "Stocking Dealer"
                          ? `<span>Stocking Dealer</span>`
                          : ""
                      }
                      <h2>${
                        dealer.business_name ? dealer.business_name : ""
                      }</h2>
                      <h3>${dealer.address ? dealer.address : ""}</h3>
                      <p>${dealer.city ? dealer.city : ""}, ${
              dealer.state_code ? dealer.state_code : ""
            } ${dealer.state ? dealer.state : ""}, ${
              dealer.zipcode ? dealer.zipcode : ""
            }</p>
                      <p>${dealer.phone ? dealer.phone : ""}</p>
                  </div>`
          );
          infoWindow.open(map, marker); // Mở InfoWindow trên marker
        }
      });

      // Thêm phần tử li vào danh sách
      listElement.appendChild(li);
    });
  }

  // Hiển thị các đại lý trên bản đồ
  function plotDealersOnMap(dealersList) {
    clearMarkers(); // Xóa các marker cũ
    // console.log(dealers);
    dealersList.forEach((dealer) => {
      // Sử dụng parseFloat để chuyển đổi latitude và longitude từ chuỗi thành số
      const latitude = parseFloat(dealer.lat);
      const longitude = parseFloat(dealer.long);

      // Kiểm tra nếu latitude và longitude hợp lệ
      if (isNaN(latitude) || isNaN(longitude)) {
        console.error(
          `Invalid latitude or longitude for dealer: ${dealer.business_name}`
        );
        return; // Bỏ qua nếu không hợp lệ
      }

      const icon = {
        url:
          dealer.dealer_type.toLowerCase() === "stocking dealer"
            ? "https://api.copperheadag.com/api-maps/pin-yellow.svg"
            : "https://api.copperheadag.com/api-maps/pin-green.svg",
        scaledSize: new google.maps.Size(48, 44), // Điều chỉnh kích thước marker
      };

      const marker = new google.maps.Marker({
        position: { lat: latitude, lng: longitude },
        map: map,
        icon: icon,
      });

      marker.addListener("click", () => {
        infoWindow.setContent(
          `<div class="popup-info-marker">
                    ${
                      dealer.dealer_type === "Stocking Dealer"
                        ? `<span>Stocking Dealer</span>`
                        : ""
                    }
                    <h2>${dealer.business_name ? dealer.business_name : ""}</h2>
                    <p>${dealer.address ? dealer.address : ""}</p>
                    <p>${dealer.city ? dealer.city : ""}, ${
            dealer.state_code ? dealer.state_code : ""
          } ${dealer.state ? dealer.state : ""}, ${
            dealer.zipcode ? dealer.zipcode : ""
          }</p>
                    <p>${dealer.phone ? dealer.phone : ""}</p>
                </div>`
        );
        infoWindow.open(map, marker); // Hiển thị popup với thông tin đại lý
      });

      // Lưu marker và đại lý tương ứng vào mảng markers
      markers.push({ dealer: dealer, marker: marker });
    });
  }

  // Xóa tất cả các marker khỏi bản đồ
  function clearMarkers() {
    markers.forEach((markerData) => {
      if (markerData.marker && typeof markerData.marker.setMap === "function") {
        markerData.marker.setMap(null); // Xóa marker khỏi bản đồ
      }
    });
    markers = []; // Đặt lại mảng markers sau khi xóa
  }

  // Xử lý khi không có vị trí người dùng
  function handleNoGeolocation(errorFlag) {
    map.setZoom(4); // Zoom ra toàn Hoa Kỳ
    map.setCenter({ lat: 37.0902, lng: -95.7129 }); // Trung tâm bản đồ là Hoa Kỳ
    document.getElementById("dealerList").innerHTML = ""; // Xóa danh sách đại lý
  }

  function clearMapAndList() {
    clearMarkers();
    document.getElementById("dealerList").innerHTML = ""; // Xóa danh sách đại lý
  }

  // Sự kiện search
  document.getElementById("search-btn")?.addEventListener("click", searchByZipOrState);

  // Sự kiện khi nhấn Enter trong ô input search
  // getElementsByClassName("search-box")
  document.getElementById("search-box")?.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        searchByZipOrState(); // Gọi hàm tìm kiếm khi nhấn Enter
      }
    });

  // Hàm xử lý tìm kiếm theo Zipcode hoặc State
  function searchByZipOrState() {
    const query = document.getElementById("search-box").value.toLowerCase();
    // const query = getElementsByClassName("search-box").value.toLowerCase();
    const errorMessageElement = document.getElementById("search-error");
    // const zipCodePattern = /^\d{5}(-\d{4})?$/;
    // Biểu thức chính quy kiểm tra mã ZIP Mỹ và mã bưu điện Canada
    const zipCodePattern = /^\d{5}(-\d{4})?$|^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
    var state_with_zip = getState(query);
    
    if (query) {
      lastQuery = query;
      let shortState = zipCodeCenter(query);
      // Kiểm tra nếu query là một bang
      if (shortState && isStateQuery(shortState.state || shortState.province)) {
        // Tìm kiếm thông tin bang và hiển thị toàn bộ khu vực bang
        removeSearchRadiusCircle();
        errorMessageElement.textContent = ""; 
        console.log(shortState.state || shortState.province);
        
        displayStateOnMapAndDealers(shortState.state || shortState.province, false, '');
      } else {
        
        const filteredDealers = dealers.filter((dealer) => {
          
          // Kiểm tra sự tồn tại của state và zipcode trước khi sử dụng includes
          const stateExists =
            dealer.state && dealer.state.toLowerCase().includes(query);
          const postalCodeExists =
            dealer.zipcode && dealer.zipcode.includes(query);

          return stateExists || postalCodeExists;
        });
       
        // console.log(filteredDealers,"filteredDealers");
        if (filteredDealers.length > 0) {
             // console.log('check1');
          errorMessageElement.textContent = ""; // Xóa thông báo lỗi nếu có đại lý được tìm thấy
          const firstDealer = filteredDealers[0];
          const searchLocation = {
            lat: parseFloat(firstDealer.lat),
            lng: parseFloat(firstDealer.long),
          };
          
          // Di chuyển bản đồ đến vị trí của đại lý đầu tiên từ kết quả tìm kiếm
          map.setCenter(searchLocation);
          map.setZoom(10); // Đặt mức zoom mặc định

          // Cập nhật phạm vi bán kính về 100 dặm và tìm kiếm lại các đại lý trong bán kính này
          searchRadius = 100; // Đặt lại bán kính tìm kiếm về 100 dặm
          searchDealersWithinRadius(searchLocation, searchRadius, 1, '');

          // Sau khi tìm kiếm, lắng nghe sự kiện zoom_changed và điều chỉnh bán kính khi người dùng zoom
           const listener2 = google.maps.event.addListener(map, "zoom_changed", () => {
            const newZoom = map.getZoom();
            const newRadius = getRadiusFromZoom(newZoom); // Tính bán kính mới dựa trên zoom
            searchDealersWithinRadius(searchLocation, newRadius, 1, lastQuery);
          });
          zoomChangedListeners.push(listener2);
         
        } else {
              // errorMessageElement.textContent =
              //   "No dealers found for the entered Zipcode or State.";
              // console.log('check2');
              clearMarkers();
              clearMapAndList();
              const normalizedZip = query.trim().padStart(5, '0');
              console.log(zipCodePattern.test(query));
              if (zipCodePattern.test(normalizedZip) && state_with_zip != 'none') {
                removeSearchRadiusCircle();
                errorMessageElement.textContent = ""; 
                
                displayStateOnMapAndDealers(state_with_zip, true, query);
              } else {
                map.setZoom(4); // Zoom ra toàn Hoa Kỳ
                map.setCenter({ lat: 37.0902, lng: -95.7129 }); // Trung tâm bản đồ là Hoa Kỳ
                // Find dealers within the radius based on user's location
                searchDealersWithinRadius(userLocation, searchRadius, 0, lastQuery);
                const listener3 = google.maps.event.addListener(map, "zoom_changed", () => {
                  const newZoom = map.getZoom();
                  const newRadius = getRadiusFromZoom(newZoom); // Tính bán kính mới dựa trên zoom
                  searchDealersWithinRadius(userLocation, newRadius, 1, lastQuery);
                });
                zoomChangedListeners.push(listener3);
              }
    
              // // Find dealers within the radius based on user's location
              // searchDealersWithinRadius(userLocation, searchRadius, 0, lastQuery);
              // const listener3 = google.maps.event.addListener(map, "zoom_changed", () => {
              //   const newZoom = map.getZoom();
              //   const newRadius = getRadiusFromZoom(newZoom); // Tính bán kính mới dựa trên zoom
              //   searchDealersWithinRadius(userLocation, newRadius, 1, lastQuery);
              // });
              // zoomChangedListeners.push(listener3);
            }
      }
    } else {
      errorMessageElement.textContent =
        "Please enter a valid Zipcode or State."; // Hiển thị lỗi nếu không nhập Zipcode hoặc State hợp lệ
    }
  }

  function isStateQuery(query) {
    const states = [
        'alabama', 'alaska', 'arizona', 'arkansas', 'california', 'colorado', 'connecticut', 'delaware',
        'florida', 'georgia', 'hawaii', 'idaho', 'illinois', 'indiana', 'iowa', 'kansas', 
        'kentucky', 'louisiana', 'maine', 'maryland', 'massachusetts', 'michigan', 'minnesota', 
        'mississippi', 'missouri', 'montana', 'nebraska', 'nevada', 'new hampshire', 'new jersey', 
        'new mexico', 'new york', 'north carolina', 'north dakota', 'ohio', 'oklahoma', 'oregon', 
        'pennsylvania', 'rhode island', 'south carolina', 'south dakota', 'tennessee', 'texas', 
        'utah', 'vermont', 'virginia', 'washington', 'west virginia', 'wisconsin', 'wyoming',
        'district of columbia', 'american samoa', 'guam', 'northern mariana islands', 
        'puerto rico', 'u.s. virgin islands', 'alberta', 'british columbia', 'manitoba', 'new brunswick', 'newfoundland and labrador', 
        'northwest territories', 'nova scotia', 'nunavut', 'ontario', 'prince edward island', 
        'quebec', 'saskatchewan', 'yukon'
    ];

    return states.includes(query.toLowerCase());
    // return Object.keys(states).includes(query.toLowerCase());
  }

  function isRegionQuery(query) {
     const statesUSA = [
        'alabama', 'alaska', 'arizona', 'arkansas', 'california', 'colorado', 'connecticut', 'delaware',
        'florida', 'georgia', 'hawaii', 'idaho', 'illinois', 'indiana', 'iowa', 'kansas', 
        'kentucky', 'louisiana', 'maine', 'maryland', 'massachusetts', 'michigan', 'minnesota', 
        'mississippi', 'missouri', 'montana', 'nebraska', 'nevada', 'new hampshire', 'new jersey', 
        'new mexico', 'new york', 'north carolina', 'north dakota', 'ohio', 'oklahoma', 'oregon', 
        'pennsylvania', 'rhode island', 'south carolina', 'south dakota', 'tennessee', 'texas', 
        'utah', 'vermont', 'virginia', 'washington', 'west virginia', 'wisconsin', 'wyoming',
        'district of columbia', 'american samoa', 'guam', 'northern mariana islands', 
        'puerto rico', 'u.s. virgin islands'
    ];
    const statesCanada = [ 
        'alberta', 'british columbia', 'manitoba', 'new brunswick', 'newfoundland and labrador', 
        'northwest territories', 'nova scotia', 'nunavut', 'ontario', 'prince edward island', 
        'quebec', 'saskatchewan', 'yukon'
    ];
    if (statesUSA.includes(query.toLowerCase())) {
      
      return 'USA';
      
    } else if(statesCanada.includes(query.toLowerCase())) {
      
      return 'CA';
      
    } else {
      return 'USA';
    }
  }
  // Hàm xử lý tìm kiếm theo bang
  function displayStateOnMapAndDealers(stateName, searchWithZipcode, userZipcode = '') {
    const errorMessageElement = document.getElementById("search-error");
    var stateToZip = zipCodeCenter(stateName); // check state return zipcode center
    const geocoder = new google.maps.Geocoder();

    let formattedStateName; // Cập nhật chuỗi tìm kiếm
    if (isRegionQuery(stateName) == 'CA') {
      formattedStateName = stateName + " state, Canada"; // Cập nhật chuỗi tìm kiếm
    } else {
      formattedStateName = stateName + " state, USA"; // Cập nhật chuỗi tìm kiếm
    }
    removeAllZoomChangedListeners();

    geocoder.geocode({ address: formattedStateName }, function(results, status) {
        // console.log(results);
        if (status === google.maps.GeocoderStatus.OK && results[0].geometry.bounds) {
            const bounds = results[0].geometry.bounds;
            const stateCenter = bounds.getCenter ? bounds.getCenter() : null;
            const shortName = results[0].address_components[0].short_name;
            // console.log(shortName);
            if (stateCenter) {
                map.fitBounds(bounds);
                console.log(searchWithZipcode, userZipcode);
                if (searchWithZipcode && userZipcode) {
                  const zip_state = getState(userZipcode);
                  if (isRegionQuery(zip_state) == 'CA') {
                    formattedStateName = userZipcode + " state, Canada"; // Cập nhật chuỗi tìm kiếm
                  } else {
                    formattedStateName = userZipcode + " state, USA"; // Cập nhật chuỗi tìm kiếm
                  }
                  geocoder.geocode({ address: formattedStateName }, function (zipResults, zipStatus) {
                        console.log(zipResults);
                        if (zipStatus === google.maps.GeocoderStatus.OK && zipResults[0].geometry.location) {
                            
                            const userLocation = {
                                lat: zipResults[0].geometry.location.lat(),
                                lng: zipResults[0].geometry.location.lng(),
                            };

                            let filteredDealers = dealers.filter(dealer =>
                                dealer.state.toLowerCase() === stateName.toLowerCase() || dealer.state.toLowerCase() === shortName.toLowerCase()
                            );

                            // Sắp xếp các đại lý theo khoảng cách từ mã ZIP
                            filteredDealers = filteredDealers.map(dealer => {
                                dealer.distance = calculateDistance(userLocation, {
                                    lat: parseFloat(dealer.lat),
                                    lng: parseFloat(dealer.long),
                                });
                                return dealer;
                            }).sort((a, b) => a.distance - b.distance);

                            const stockingDealers = filteredDealers.filter(dealer =>
                                dealer.dealer_type === "Stocking Dealer"
                            );

                            clearMarkers();
                            if (activeMarker) {
                                activeMarker.setMap(null);
                            }
                            const locationCenter = {
                                lat: parseFloat(stateCenter.lat()),
                                lng: parseFloat(stateCenter.lng()),
                            };

                            if (filteredDealers.length > 0) {
                                if (stockingDealers.length === 0) {
                                    updateDealerList(filteredDealers, locationCenter);
                                    plotDealersOnMap(filteredDealers);
                                } else {
                                    updateDealerList(filteredDealers);
                                    plotDealersOnMap(filteredDealers);
                                }
                            }  else {
                                clearMapAndList();
                                errorMessageElement.textContent = "No dealers found in this state.";
                                map.setZoom(4); // Zoom ra toàn Hoa Kỳ
                                map.setCenter({ lat: 37.0902, lng: -95.7129 }); // Trung tâm bản đồ là Hoa Kỳ
                                // Find dealers within the radius based on user's location
                                searchDealersWithinRadius(userLocation, searchRadius, 0, lastQuery);
                            }
                        } else {
                            console.error("Could not geocode the ZIP code.");
                        }
                    });
                } else {
                    console.log(stateName, formattedStateName);
                    
                    let filteredDealers = dealers.filter(dealer => 
                      dealer.state.toLowerCase() === stateName.toLowerCase() || dealer.state.toLowerCase() === shortName.toLowerCase()
                    );
                    
                    const stockingDealers = filteredDealers.filter(dealer => 
                        dealer.dealer_type === "Stocking Dealer"
                    );
                    
                    const locationCenter = {
                        lat: parseFloat(stateCenter.lat()),
                        lng: parseFloat(stateCenter.lng()),
                    };
                    console.log(locationCenter);
                    clearMarkers();
                    if (activeMarker) {
                        activeMarker.setMap(null);
                    }
    
                    if (filteredDealers.length > 0) {
                        if (stockingDealers.length === 0) {
                            updateDealerList(filteredDealers, locationCenter);
                            plotDealersOnMap(filteredDealers);
                        } else {
                            updateDealerList(filteredDealers);
                            plotDealersOnMap(filteredDealers);
                        }
                    } else if (filteredDealers.length <= 0 && stateToZip != null) {
                        //Finds the ZIP code center of a given state. => Finds locations (dealers) near that ZIP code center based on distance.
                        const searchLocation = {
                          lat: parseFloat(stateToZip.latitude),
                          lng: parseFloat(stateToZip.longitude),
                        };
                        console.log(searchLocation);
                        removeSearchRadiusCircle();
                        clearMarkers();
                        if (activeMarker) {
                            activeMarker.setMap(null);
                        }
                        searchRadius = 100; // Đặt lại bán kính tìm kiếm về 100 dặm
                        searchDealersWithinRadius(searchLocation, searchRadius, 1, '');
                        removeSearchRadiusCircle();
                         const listener3 = google.maps.event.addListener(map, "zoom_changed", () => {
                          const newZoom = map.getZoom();
                          const newRadius = getRadiusFromZoom(newZoom); // Tính bán kính mới dựa trên zoom
                          searchDealersWithinRadius(searchLocation, newRadius, 1, stateName);
                          removeSearchRadiusCircle();
                        });
                        zoomChangedListeners.push(listener3);
                        return;
                    } else {
                        clearMapAndList();
                        errorMessageElement.textContent = "No dealers found in this state.";
                        map.setZoom(4); // Zoom ra toàn Hoa Kỳ
                        map.setCenter({ lat: 37.0902, lng: -95.7129 }); // Trung tâm bản đồ là Hoa Kỳ
                        // Find dealers within the radius based on user's location
                        searchDealersWithinRadius(userLocation, searchRadius, 0, lastQuery);
                    }
                  
                }
               
            } else {
                console.error("Could not determine center for the state bounds.");
            }
        } else {
            console.error("Geocode was not successful for the following reason: " + status);
        }
    });
  }


  function removeAllZoomChangedListeners() {
    zoomChangedListeners.forEach(listener => {
        google.maps.event.removeListener(listener);
    });
    zoomChangedListeners = []; // Đặt lại mảng sau khi xóa tất cả
  }
  

  
    //check state return zip code center 
   function zipCodeCenter(stateString) {
      // List of ZIP/postal code centers for U.S. states and Canadian provinces
      const zipCodeCenters = [
          {"state": "alabama", "state_abbr": "AL", "zipcode_center": "36104", "latitude": 32.3668, "longitude": -86.3000},
          {"state": "alaska", "state_abbr": "AK", "zipcode_center": "99801", "latitude": 58.3019, "longitude": -134.4197},
          {"state": "arizona", "state_abbr": "AZ", "zipcode_center": "85007", "latitude": 33.4484, "longitude": -112.0740},
          {"state": "arkansas", "state_abbr": "AR", "zipcode_center": "72201", "latitude": 34.7465, "longitude": -92.2896},
          {"state": "california", "state_abbr": "CA", "zipcode_center": "95814", "latitude": 38.5816, "longitude": -121.4944},
          {"state": "colorado", "state_abbr": "CO", "zipcode_center": "80202", "latitude": 39.7392, "longitude": -104.9903},
          {"state": "connecticut", "state_abbr": "CT", "zipcode_center": "06103", "latitude": 41.7658, "longitude": -72.6734},
          {"state": "delaware", "state_abbr": "DE", "zipcode_center": "19901", "latitude": 39.1582, "longitude": -75.5244},
          {"state": "florida", "state_abbr": "FL", "zipcode_center": "32301", "latitude": 30.4383, "longitude": -84.2807},
          {"state": "georgia", "state_abbr": "GA", "zipcode_center": "30303", "latitude": 33.7490, "longitude": -84.3880},
          {"state": "hawaii", "state_abbr": "HI", "zipcode_center": "96813", "latitude": 21.3069, "longitude": -157.8583},
          {"state": "idaho", "state_abbr": "ID", "zipcode_center": "83702", "latitude": 43.6150, "longitude": -116.2023},
          {"state": "illinois", "state_abbr": "IL", "zipcode_center": "62701", "latitude": 39.7817, "longitude": -89.6501},
          {"state": "indiana", "state_abbr": "IN", "zipcode_center": "46204", "latitude": 39.7684, "longitude": -86.1581},
          {"state": "iowa", "state_abbr": "IA", "zipcode_center": "50309", "latitude": 41.5868, "longitude": -93.6250},
          {"state": "kansas", "state_abbr": "KS", "zipcode_center": "66603", "latitude": 39.0483, "longitude": -95.6771},
          {"state": "kentucky", "state_abbr": "KY", "zipcode_center": "40601", "latitude": 38.2009, "longitude": -84.8733},
          {"state": "louisiana", "state_abbr": "LA", "zipcode_center": "70802", "latitude": 30.4515, "longitude": -91.1871},
          {"state": "maine", "state_abbr": "ME", "zipcode_center": "04330", "latitude": 44.3106, "longitude": -69.7795},
          {"state": "maryland", "state_abbr": "MD", "zipcode_center": "21401", "latitude": 38.9784, "longitude": -76.4922},
          {"state": "massachusetts", "state_abbr": "MA", "zipcode_center": "02201", "latitude": 42.3601, "longitude": -71.0589},
          {"state": "michigan", "state_abbr": "MI", "zipcode_center": "48933", "latitude": 42.7325, "longitude": -84.5555},
          {"state": "minnesota", "state_abbr": "MN", "zipcode_center": "55101", "latitude": 44.9537, "longitude": -93.0900},
          {"state": "mississippi", "state_abbr": "MS", "zipcode_center": "39205", "latitude": 32.2988, "longitude": -90.1848},
          {"state": "missouri", "state_abbr": "MO", "zipcode_center": "65101", "latitude": 38.5767, "longitude": -92.1735},
          {"state": "montana", "state_abbr": "MT", "zipcode_center": "59601", "latitude": 46.5891, "longitude": -112.0391},
          {"state": "nebraska", "state_abbr": "NE", "zipcode_center": "68502", "latitude": 40.8136, "longitude": -96.7026},
          {"state": "nevada", "state_abbr": "NV", "zipcode_center": "89701", "latitude": 39.1638, "longitude": -119.7674},
          {"state": "new hampshire", "state_abbr": "NH", "zipcode_center": "03301", "latitude": 43.2081, "longitude": -71.5376},
          {"state": "new jersey", "state_abbr": "NJ", "zipcode_center": "08608", "latitude": 40.2206, "longitude": -74.7699},
          {"state": "new mexico", "state_abbr": "NM", "zipcode_center": "87501", "latitude": 35.6870, "longitude": -105.9378},
          {"state": "new york", "state_abbr": "NY", "zipcode_center": "12207", "latitude": 42.6526, "longitude": -73.7562},
          {"state": "north carolina", "state_abbr": "NC", "zipcode_center": "27601", "latitude": 35.7796, "longitude": -78.6382},
          {"state": "north dakota", "state_abbr": "ND", "zipcode_center": "58501", "latitude": 46.8083, "longitude": -100.7837},
          {"state": "ohio", "state_abbr": "OH", "zipcode_center": "43215", "latitude": 39.9612, "longitude": -82.9988},
          {"state": "oklahoma", "state_abbr": "OK", "zipcode_center": "73102", "latitude": 35.4676, "longitude": -97.5164},
          {"state": "oregon", "state_abbr": "OR", "zipcode_center": "97301", "latitude": 44.9429, "longitude": -123.0351},
          {"state": "pennsylvania", "state_abbr": "PA", "zipcode_center": "17101", "latitude": 40.2732, "longitude": -76.8867},
          {"state": "rhode island", "state_abbr": "RI", "zipcode_center": "02903", "latitude": 41.8236, "longitude": -71.4222},
          {"state": "south carolina", "state_abbr": "SC", "zipcode_center": "29201", "latitude": 34.0007, "longitude": -81.0348},
          {"state": "south dakota", "state_abbr": "SD", "zipcode_center": "57501", "latitude": 44.3683, "longitude": -100.3510},
          {"state": "tennessee", "state_abbr": "TN", "zipcode_center": "37219", "latitude": 36.1627, "longitude": -86.7816},
          {"state": "texas", "state_abbr": "TX", "zipcode_center": "78701", "latitude": 30.2672, "longitude": -97.7431},
          {"state": "utah", "state_abbr": "UT", "zipcode_center": "84111", "latitude": 40.7608, "longitude": -111.8910},
          {"state": "vermont", "state_abbr": "VT", "zipcode_center": "05602", "latitude": 44.2601, "longitude": -72.5754},
          {"state": "virginia", "state_abbr": "VA", "zipcode_center": "23219", "latitude": 37.5407, "longitude": -77.4360},
          {"state": "washington", "state_abbr": "WA", "zipcode_center": "98507", "latitude": 47.0379, "longitude": -122.9007},
          {"state": "west virginia", "state_abbr": "WV", "zipcode_center": "25301", "latitude": 38.3498, "longitude": -81.6326},
          {"state": "wisconsin", "state_abbr": "WI", "zipcode_center": "53703", "latitude": 43.0731, "longitude": -89.4012},
          {"state": "wyoming", "state_abbr": "WY", "zipcode_center": "82001", "latitude": 41.1400, "longitude": -104.8202},
          {"province": "alberta", "province_abbr": "AB", "zipcode_center": "T5K", "latitude": 53.5461, "longitude": -113.4938},
          {"province": "british columbia", "province_abbr": "BC", "zipcode_center": "V8V", "latitude": 48.4284, "longitude": -123.3656},
          {"province": "manitoba", "province_abbr": "MB", "zipcode_center": "R3C", "latitude": 49.8951, "longitude": -97.1384},
          {"province": "new brunswick", "province_abbr": "NB", "zipcode_center": "E3B", "latitude": 45.9636, "longitude": -66.6431},
          {"province": "newfoundland and labrador", "province_abbr": "NL", "zipcode_center": "A1C", "latitude": 47.5615, "longitude": -52.7126},
          {"province": "northwest territories", "province_abbr": "NT", "zipcode_center": "X1A", "latitude": 62.4540, "longitude": -114.3718},
          {"province": "nova scotia", "province_abbr": "NS", "zipcode_center": "B3J", "latitude": 44.6488, "longitude": -63.5752},
          {"province": "nunavut", "province_abbr": "NU", "zipcode_center": "X0A", "latitude": 63.7467, "longitude": -68.5170},
          {"province": "ontario", "province_abbr": "ON", "zipcode_center": "M5H", "latitude": 43.6532, "longitude": -79.3832},
          {"province": "prince edward island", "province_abbr": "PE", "zipcode_center": "C1A", "latitude": 46.2382, "longitude": -63.1311},
          {"province": "quebec", "province_abbr": "QC", "zipcode_center": "G1R", "latitude": 46.8139, "longitude": -71.2082},
          {"province": "saskatchewan", "province_abbr": "SK", "zipcode_center": "S4P", "latitude": 50.4452, "longitude": -104.6189},
          {"province": "yukon", "province_abbr": "YT", "zipcode_center": "Y1A", "latitude": 60.7212, "longitude": -135.0568}
      ];
  
      // Normalize input to lowercase and trim spaces
      const normalizedState = stateString.toLowerCase().trim();
  
      // Find the corresponding ZIP code center
      const stateInfo = zipCodeCenters.find(
        (item) =>
            item.state === normalizedState ||
            item.province === normalizedState ||
            item.state_abbr?.toLowerCase() === normalizedState ||  // Check short state
            item.province_abbr?.toLowerCase() === normalizedState  // Check short province
      );
  
      // Return the ZIP/postal code center if found, otherwise return null
      return stateInfo ? stateInfo : null;
    }



  
    function getState(zipString) {

    // Ensure input is a string
    if (typeof zipString !== 'string') {
        console.error('Zipcode must be a string.');
        return { st: 'none', state: 'none' };
    }

    // Normalize input for Canada (remove spaces and uppercase)
    // const normalizedZip = zipString.toUpperCase().replace(/\s+/g, '');
    const normalizedZip = zipString.toUpperCase().replace(/\s+/g, '').padStart(5, '0');

    let st, state;
    // console.log(normalizedZip);
    // Check for US zipcodes
    if (normalizedZip.length === 5 && /^\d{5}$/.test(normalizedZip)) {
        // const zipcode = parseInt(normalizedZip, 10);
        const zipcode = normalizedZip;
        console.log(zipcode);
        /* Code cases alphabetized by state */
        if (zipcode >= 35000 && zipcode <= 36999) {
            st = 'AL';
            state = 'Alabama';
        } else if (zipcode >= 99500 && zipcode <= 99999) {
            st = 'AK';
            state = 'Alaska';
        } else if (zipcode >= 85000 && zipcode <= 86999) {
            st = 'AZ';
            state = 'Arizona';
        } else if (zipcode >= 71600 && zipcode <= 72999) {
            st = 'AR';
            state = 'Arkansas';
        } else if (zipcode >= 90000 && zipcode <= 96699) {
            st = 'CA';
            state = 'California';
        } else if (zipcode >= 80000 && zipcode <= 81999) {
            st = 'CO';
            state = 'Colorado';
        } else if ((zipcode >= 6000 && zipcode <= 6389) || (zipcode >= 6391 && zipcode <= 6999)) {
            st = 'CT';
            state = 'Connecticut';
        } else if (zipcode >= 19700 && zipcode <= 19999) {
            st = 'DE';
            state = 'Delaware';
        } else if (zipcode >= 32000 && zipcode <= 34999) {
            st = 'FL';
            state = 'Florida';
        } else if ( (zipcode >= 30000 && zipcode <= 31999) || (zipcode >= 39800 && zipcode <= 39999) ) {
            st = 'GA';
            state = 'Georgia';
        } else if (zipcode >= 96700 && zipcode <= 96999) {
            st = 'HI';
            state = 'Hawaii';
        } else if (zipcode >= 83200 && zipcode <= 83999 && zipcode != 83414) {
            st = 'ID';
            state = 'Idaho';
        } else if (zipcode >= 60000 && zipcode <= 62999) {
            st = 'IL';
            state = 'Illinois';
        } else if (zipcode >= 46000 && zipcode <= 47999) {
            st = 'IN';
            state = 'Indiana';
        } else if (zipcode >= 50000 && zipcode <= 52999) {
            st = 'IA';
            state = 'Iowa';
        } else if (zipcode >= 66000 && zipcode <= 67999) {
            st = 'KS';
            state = 'Kansas';
        } else if (zipcode >= 40000 && zipcode <= 42999) {
            st = 'KY';
            state = 'Kentucky';
        } else if (zipcode >= 70000 && zipcode <= 71599) {
            st = 'LA';
            state = 'Louisiana';
        } else if (zipcode >= 3900 && zipcode <= 4999) {
            st = 'ME';
            state = 'Maine';
        } else if (zipcode >= 20600 && zipcode <= 21999) {
            st = 'MD';
            state = 'Maryland';
        } else if ( (zipcode >= 1000 && zipcode <= 2799) || (zipcode == 5501) || (zipcode == 5544 ) ) {
            st = 'MA';
            state = 'Massachusetts';
        } else if (zipcode >= 48000 && zipcode <= 49999) {
            st = 'MI';
            state = 'Michigan';
        } else if (zipcode >= 55000 && zipcode <= 56899) {
            st = 'MN';
            state = 'Minnesota';
        } else if (zipcode >= 38600 && zipcode <= 39999) {
            st = 'MS';
            state = 'Mississippi';
        } else if (zipcode >= 63000 && zipcode <= 65999) {
            st = 'MO';
            state = 'Missouri';
        } else if (zipcode >= 59000 && zipcode <= 59999) {
            st = 'MT';
            state = 'Montana';
        } else if (zipcode >= 27000 && zipcode <= 28999) {
            st = 'NC';
            state = 'North Carolina';
        } else if (zipcode >= 58000 && zipcode <= 58999) {
            st = 'ND';
            state = 'North Dakota';
        } else if (zipcode >= 68000 && zipcode <= 69999) {
            st = 'NE';
            state = 'Nebraska';
        } else if (zipcode >= 88900 && zipcode <= 89999) {
            st = 'NV';
            state = 'Nevada';
        } else if (zipcode >= 3000 && zipcode <= 3899) {
            st = 'NH';
            state = 'New Hampshire';
        } else if (zipcode >= 7000 && zipcode <= 8999) {
            st = 'NJ';
            state = 'New Jersey';
        } else if (zipcode >= 87000 && zipcode <= 88499) {
            st = 'NM';
            state = 'New Mexico';
        } else if ( (zipcode >= 10000 && zipcode <= 14999) || (zipcode == 6390) || (zipcode == 501) || (zipcode == 544) ) {
            st = 'NY';
            state = 'New York';
        } else if (zipcode >= 43000 && zipcode <= 45999) {
            st = 'OH';
            state = 'Ohio';
        } else if ((zipcode >= 73000 && zipcode <= 73199) || (zipcode >= 73400 && zipcode <= 74999) ) {
            st = 'OK';
            state = 'Oklahoma';
        } else if (zipcode >= 97000 && zipcode <= 97999) {
            st = 'OR';
            state = 'Oregon';
        } else if (zipcode >= 15000 && zipcode <= 19699) {
            st = 'PA';
            state = 'Pennsylvania';
        } else if (zipcode >= 300 && zipcode <= 999) {
            st = 'PR';
            state = 'Puerto Rico';
        } else if (zipcode >= 2800 && zipcode <= 2999) {
            st = 'RI';
            state = 'Rhode Island';
        } else if (zipcode >= 29000 && zipcode <= 29999) {
            st = 'SC';
            state = 'South Carolina';
        } else if (zipcode >= 57000 && zipcode <= 57999) {
            st = 'SD';
            state = 'South Dakota';
        } else if (zipcode >= 37000 && zipcode <= 38599) {
            st = 'TN';
            state = 'Tennessee';
        } else if ( (zipcode >= 75000 && zipcode <= 79999) || (zipcode >= 73301 && zipcode <= 73399) ||  (zipcode >= 88500 && zipcode <= 88599) ) {
            st = 'TX';
            state = 'Texas';
        } else if (zipcode >= 84000 && zipcode <= 84999) {
            st = 'UT';
            state = 'Utah';
        } else if (zipcode >= 5000 && zipcode <= 5999) {
            st = 'VT';
            state = 'Vermont';
        } else if ( (zipcode >= 20100 && zipcode <= 20199) || (zipcode >= 22000 && zipcode <= 24699) || (zipcode == 20598) ) {
            st = 'VA';
            state = 'Virginia';
        } else if ( (zipcode >= 20000 && zipcode <= 20099) || (zipcode >= 20200 && zipcode <= 20599) || (zipcode >= 56900 && zipcode <= 56999) ) {
            st = 'DC';
            state = 'Washington DC';
        } else if (zipcode >= 98000 && zipcode <= 99499) {
            st = 'WA';
            state = 'Washington';
        } else if (zipcode >= 24700 && zipcode <= 26999) {
            st = 'WV';
            state = 'West Virginia';
        } else if (zipcode >= 53000 && zipcode <= 54999) {
            st = 'WI';
            state = 'Wisconsin';
        } else if ( (zipcode >= 82000 && zipcode <= 83199) || zipcode == 83414 ) {
            st = 'WY';
            state = 'Wyoming';
        } else {
            st = 'none';
            state = 'none';
            // console.log('No state found matching', zipcode);
          }
      console.log(st, state);
    } else if (normalizedZip.length === 6 && /^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(normalizedZip)) {
       // Check for Canadian postal codes
        if (normalizedZip.startsWith('A')) {
            st = 'NL';
            state = 'Newfoundland and Labrador';
        } else if (normalizedZip.startsWith('B')) {
            st = 'NS';
            state = 'Nova Scotia';
        } else if (normalizedZip.startsWith('C')) {
            st = 'PE';
            state = 'Prince Edward Island';
        } else if (normalizedZip.startsWith('E')) {
            st = 'NB';
            state = 'New Brunswick';
        } else if (normalizedZip.startsWith('G') || normalizedZip.startsWith('H') || normalizedZip.startsWith('J')) {
            st = 'QC';
            state = 'Quebec';
        } else if (normalizedZip.startsWith('K') || normalizedZip.startsWith('L') || normalizedZip.startsWith('M') || normalizedZip.startsWith('N') || normalizedZip.startsWith('P')) {
            st = 'ON';
            state = 'Ontario';
        } else if (normalizedZip.startsWith('R')) {
            st = 'MB';
            state = 'Manitoba';
        } else if (normalizedZip.startsWith('S')) {
            st = 'SK';
            state = 'Saskatchewan';
        } else if (normalizedZip.startsWith('T')) {
            st = 'AB';
            state = 'Alberta';
        } else if (normalizedZip.startsWith('V')) {
            st = 'BC';
            state = 'British Columbia';
        } else if (normalizedZip.startsWith('X')) {
            st = 'NT/NU';
            state = 'Northwest Territories/Nunavut';
        } else if (normalizedZip.startsWith('Y')) {
            st = 'YT';
            state = 'Yukon';
        } else {
            st = 'none';
            state = 'none';
        }
    } else {
        st = 'none';
        state = 'none';
    }

    return state;
  }
});
